import React, { useEffect } from "react";
import { Route, BrowserRouter, Routes } from 'react-router-dom';

import routes from './components/pages/index';
import Login from './components/Admin/Login';
import Authentication from './components/Admin/Authentication';
import MainLayout from './components/Admin/MainLayout';
import Authorization from './components/Admin/Authorization';
import Dashboard from './components/Admin/Dashboard';
import Buyer from './components/Admin/Buyer';
import Payment from './components/pages/Payment';
import TagManager from "react-gtm-module";

function App() {

   useEffect(() => {
     const tagManagerArgs = {
       gtmId: "G-8KECGFL3LH", // Replace with your GTM ID
     };
     TagManager.initialize(tagManagerArgs);
   }, []);
   
  return (
    <BrowserRouter>
      <Routes>

        {
          routes.map((route, idx) => (
            <Route exact path={route.path} element={route.component} key={idx} ></Route>

          ))

        }
        <Route path="/payment" element={<Payment />}></Route>
        <Route path="/admin/login" element={<Login />}></Route>
        <Route element={<Authentication />}>
          <Route path="portal" element={<MainLayout />}>
            <Route element={<Authorization allowedRoles={["admin"]} />}>
              <Route path="/portal/dashboard" element={<Dashboard />} />
              <Route path="/portal/buyers" element={<Buyer />} />
            </Route>
          </Route>
        </Route>
      </Routes>

    </BrowserRouter>
  );
}

export default App;

